import { useIntl } from "react-intl";
import { type BasicUsageCardLoaderProps, UsageCard } from "./UsageCard.js";
import { calculateUsageCost, TieredPriceProductId } from "@project/common";
import { IconLayersSubtract } from "@tabler/icons-react";
import { INTERNATIONALIZED_UNIT_LABELS } from "../../../constants/productLabels.js";
import { useCustomTilesetUsageSum } from "./hooks/fetchSums.js";
import { useProductDescriptions, useProductNames } from "./hooks/productLabels.js";
import type { To } from "./UsageChartWrapper.js";

export function CustomTilesetsUsageCard({
  to,
  productId,
  isLoadingSubscriptions,
}: BasicUsageCardLoaderProps & To) {
  const intl = useIntl();
  const { usageSum, isLoadingTilesets, isErrorTilesets } = useCustomTilesetUsageSum({ to });

  const getName = useProductNames();
  const getDescription = useProductDescriptions();
  const unitLabel = intl.formatMessage(INTERNATIONALIZED_UNIT_LABELS.tileset);

  return (
    <UsageCard
      productId={productId}
      usageSum={usageSum}
      unitLabel={unitLabel}
      isError={isErrorTilesets}
      iconColor="info.2"
      icon={<IconLayersSubtract />}
      isLoading={isLoadingSubscriptions || isLoadingTilesets}
      usageCost={calculateUsageCost(usageSum, productId)}
      defaultProductId={TieredPriceProductId.TieredCustomTileset}
      name={getName(TieredPriceProductId.TieredCustomTileset)}
      description={getDescription(TieredPriceProductId.TieredCustomTileset)}
    />
  );
};
